export default [
  {
    name: 'upgradeAnnouncement',
    path: '/systematicOperation/upgradeAnnouncement',
    component: () => import('@/views/systematicOperation/upgradeAnnouncement/index.vue'),
    meta: {
      title: '升级公告'
    },
  },
  {
    name: 'dictManagement',
    path: '/systematicOperation/dictManagement',
    component: () => import('@/views/systematicOperation/dictManagement/index.vue'),
    meta: {
      title: '字典管理'
    },
  },
  {
    name: 'systemParamsConfig',
    path: '/systematicOperation/systemParamsConfig',
    component: () => import('@/views/systematicOperation/systemParamsConfig/index.vue'),
    meta: {
      title: '系统参数配置'
    },
  },
  {
    name: 'dingRoleManagement',
    path: '/systematicOperation/dingRoleManagement',
    component: () => import('@/views/systematicOperation/dingRoleManagement/index.vue'),
    meta: {
      title: '钉钉应用角色管理'
    },
  },
  {
    name: 'dingRoleConfig',
    path: '/systematicOperation/dingRoleConfig',
    component: () => import('@/views/systematicOperation/dingRoleConfig/index.vue'),
    meta: {
      title: '钉钉角色配置'
    },
  }
]
